const basePath = '/api/v1.0/staff/appointments/welcome-call';
export enum FirstShiftHttpPaths {
  bookingStatus = `${basePath}/cancelled-and-missed`,
  activeBooking = `${basePath}/upcoming`,
  welcomeCallSlots = `${basePath}/slots`,
  bookTimeSlot = `${basePath}/{###}/book`,
  rescheduleTimeSlot = `${basePath}/{###}/reschedule`,
  attended = `${basePath}/attended`,
  amendPhoneNumber = '/api/v1.0/staff/phone-numbers/amend',
  cancelAppointment = `${basePath}/cancel`,
}
